import { useState } from 'react';
import {
  fetchSecondaryOfferingListAction,
  fetchSecondartOfferingWebListAction,
  fetchSecondaryOfferingMobileListAction,
} from '../store/reducer/secondaryOfferingSlice';
import {
  fetchInitialOfferingListAction,
  fetchInitialOfferingWebListAction,
  fetchInitialOfferingMobileListAction,
} from '../store/reducer/initialOfferingSlice';
import { useDispatch } from 'react-redux';
import { updateFilterApply } from '../store/reducer/filtersSlice';

const useFilters = (setmobilePage) => {
  const dispatch = useDispatch();

  const [priceRange, setPriceRange] = useState([0, 10000]);
  const [currentPage, setCurrentPage] = useState(1);
  const [priceRangeTemp, setPriceRangeTemp] = useState([0, 10000]);
  const [selectedLocation, setSelectedLocation] = useState([]);
  const [selectedPropertyType, setSelectedPropertyType] = useState([]);
  const [selectedLeverages, setSelectedLeverages] = useState([]);
  const [searchedLocation, setSearchedLocation] = useState('');
  const [savedProperty, setSavedProperty] = useState(false);
  const [ownProperty, setOwnProperty] = useState(false);
  const [dividendPaidProperty, setdividendPaidProperty] = useState(false);
  const [sortType, setSortType] = useState('Newest');
  const [marketPlaceSearch, setMarketPlaceSearch] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [savedPropertyTemp, setSavedPropertyTemp] = useState(false);
  const [ownPropertyTemp, setOwnPropertyTemp] = useState(false);
  const [dividendPaidPropertyTemp, setdividendPaidPropertyTemp] = useState(false);
  const [tempSelectedProperty, setTempSelectedProperty] = useState([]);
  const [selectedLeveragesTemp, setSelectedLeveragesTemp] = useState([]);
  const [tempselectedLocation, setTempSelectedLocation] = useState([]);
  const [isResetClick, setIsResetClick] = useState(false);

  const handleApplyFilter = async (
    locations,
    savedProperty,
    ownProperty,
    dividendPaidProperty,
    propertyType,
    leverages,
    priceRange,
    sortType,
    marketPlaceSearch,
    isSecondary
  ) => {
    let locationString = '';
    let propertyTypeString = '';
    let leverageString = '';
    setCurrentPage(1);
    if (locations?.length > 0) {
      locations?.forEach((item, index) => {
        locationString = locationString + `location[]=${item?.cityId}${locations.length - 1 !== index ? '&' : ''}`;
      });
    }
    if (propertyType?.length > 0) {
      propertyType?.forEach((item, index) => {
        propertyTypeString = propertyTypeString + `propertyType[]=${item?.propertyTypeId}${propertyType.length - 1 !== index ? '&' : ''}`;
      });
    }
    if (leverages?.length > 0) {
      leverages?.forEach((item, index) => {
        leverageString = leverageString + `leverage=${item}${leverages.length - 1 !== index ? '&' : ''}`;
      });
    }
    await dispatch(updateFilterApply(true));
    if (isSecondary) {
      await dispatch(
        fetchSecondaryOfferingListAction({
          page: 1,
          perPage: 10,
          locationString,
          savedProperty,
          ownProperty,
          dividendPaidProperty,
          propertyTypeString,
          leverageString,
          priceRange,
          sortType,
          marketPlaceSearch,
        })
      );
    } else {
      await dispatch(
        fetchInitialOfferingListAction({
          page: 1,
          perPage: 10,
          locationString,
          savedProperty,
          ownProperty,
          dividendPaidProperty,
          propertyTypeString,
          leverageString,
          priceRange,
          sortType,
          marketPlaceSearch,
        })
      );
    }
  };

  const handleNextPage = async (page = currentPage, isSecondary) => {
    setCurrentPage(page);
    let locationString = '';
    let propertyTypeString = '';
    let leverageString = '';
    if (selectedLocation?.length > 0) {
      selectedLocation?.forEach((item, index) => {
        locationString = locationString + `location[]=${item?.cityId}${selectedLocation.length - 1 !== index ? '&' : ''}`;
      });
    }
    if (selectedPropertyType?.length > 0) {
      selectedPropertyType?.forEach((item, index) => {
        propertyTypeString = propertyTypeString + `propertyType[]=${item?.propertyTypeId}${selectedPropertyType.length - 1 !== index ? '&' : ''}`;
      });
    }
    if (selectedLeverages?.length > 0) {
      selectedLeverages?.forEach((item, index) => {
        leverageString = leverageString + `leverage=${item}${selectedLeverages.length - 1 !== index ? '&' : ''}`;
      });
    }
    if (isSecondary) {
      await dispatch(
        fetchSecondartOfferingWebListAction({
          page: page,
          perPage: 10,
          locationString,
          savedProperty,
          ownProperty,
          dividendPaidProperty,
          propertyTypeString,
          leverageString,
          priceRange,
          sortType,
          marketPlaceSearch,
        })
      );
    } else {
      await dispatch(
        fetchInitialOfferingWebListAction({
          page: page,
          perPage: 10,
          locationString,
          savedProperty,
          ownProperty,
          dividendPaidProperty,
          propertyTypeString,
          leverageString,
          priceRange,
          sortType,
          marketPlaceSearch,
        })
      );
    }
  };

  const handleScrolltoBottom = async (isVisible, mobilePage, propertyListMobileData, isSecondary) => {
    if (isVisible && propertyListMobileData?.data?.properties?.length !== propertyListMobileData?.data?.count) {
      let locationString = '';
      let propertyTypeString = '';
      let leverageString = '';
      if (selectedLocation?.length > 0) {
        selectedLocation?.forEach((item, index) => {
          locationString = locationString + `location[]=${item?.cityId}${selectedLocation.length - 1 !== index ? '&' : ''}`;
        });
      }
      if (selectedPropertyType?.length > 0) {
        selectedPropertyType?.forEach((item, index) => {
          propertyTypeString = propertyTypeString + `propertyType[]=${item?.propertyTypeId}${selectedPropertyType.length - 1 !== index ? '&' : ''}`;
        });
      }
      if (selectedLeverages?.length > 0) {
        selectedLeverages?.forEach((item, index) => {
          leverageString = leverageString + `leverage=${item}${selectedLeverages.length - 1 !== index ? '&' : ''}`;
        });
      }
      if (!isSecondary) {
        await dispatch(
          fetchInitialOfferingMobileListAction({
            page: mobilePage + 1,
            perPage: 10,
            locationString,
            savedProperty,
            ownProperty,
            dividendPaidProperty,
            propertyTypeString,
            leverageString,
            priceRange,
            sortType,
            marketPlaceSearch,
          })
        );
      } else {
        await dispatch(
          fetchSecondaryOfferingMobileListAction({
            page: mobilePage + 1,
            perPage: 10,
            locationString,
            savedProperty,
            ownProperty,
            dividendPaidProperty,
            propertyTypeString,
            leverageString,
            priceRange,
            sortType,
            marketPlaceSearch,
          })
        );
      }
      setmobilePage(mobilePage + 1);
    }
  };

  const handleRemoveFilter = async (
    selectedLocation,
    savedProperty,
    ownProperty,
    dividendPaidProperty,
    selectedPropertyType,
    selectedLeverages,
    priceRange,
    sortType,
    marketPlaceSearch,
    isSecondary
  ) => {
    await dispatch(updateFilterApply(false));
    handleApplyFilter(
      selectedLocation,
      savedProperty,
      ownProperty,
      dividendPaidProperty,
      selectedPropertyType,
      selectedLeverages,
      priceRange,
      sortType,
      marketPlaceSearch,
      isSecondary
    );
  };

  const handleRemoveLeverage = (isSecondary) => {
    setSelectedLeverages([]);
    setSelectedLeveragesTemp([]);
    handleApplyFilter(
      selectedLocation,
      savedProperty,
      ownProperty,
      dividendPaidProperty,
      selectedPropertyType,
      [],
      priceRange,
      sortType,
      marketPlaceSearch,
      isSecondary
    );
  };

  const handleRemoveLocationFilter = (isSecondary) => {
    setSelectedLocation([]);
    setTempSelectedLocation([]);
    handleApplyFilter(
      [],
      savedProperty,
      ownProperty,
      dividendPaidProperty,
      selectedPropertyType,
      selectedLeverages,
      priceRange,
      sortType,
      marketPlaceSearch,
      isSecondary
    );
  };

  const handleResetAllFilters = async (isSecondary) => {
    await dispatch(updateFilterApply(false));
    setIsResetClick(true);
    setSelectedLeveragesTemp([]);
    setSearchTerm('');
    setTempSelectedProperty([]);
    setPriceRange([0, 10000]);
    setPriceRangeTemp([0, 10000]);
    setSelectedLocation([]);
    setTempSelectedLocation([]);
    setSelectedPropertyType([]);
    setSelectedLeverages([]);
    setSearchedLocation('');
    setSavedProperty(false);
    setOwnProperty(false);
    setdividendPaidProperty(false);
    setSavedPropertyTemp(false);
    setOwnPropertyTemp(false);
    setdividendPaidPropertyTemp(false);
    setSortType('Newest');
    setMarketPlaceSearch('');
    handleRemoveFilter([], false, false, false, [], [], [0, 10000], 'Newest', '', isSecondary);
  };

  return {
    handleApplyFilter,
    handleRemoveFilter,
    handleNextPage,
    handleScrolltoBottom,
    selectedLocation,
    setSelectedLocation,
    priceRange,
    setPriceRange,
    selectedPropertyType,
    setSelectedPropertyType,
    selectedLeverages,
    setSelectedLeverages,
    searchedLocation,
    setSearchedLocation,
    savedProperty,
    setSavedProperty,
    ownProperty,
    setOwnProperty,
    dividendPaidProperty,
    setdividendPaidProperty,
    sortType,
    setSortType,
    marketPlaceSearch,
    setMarketPlaceSearch,
    searchTerm,
    setSearchTerm,
    savedPropertyTemp,
    setSavedPropertyTemp,
    ownPropertyTemp,
    setOwnPropertyTemp,
    dividendPaidPropertyTemp,
    setdividendPaidPropertyTemp,
    tempSelectedProperty,
    setTempSelectedProperty,
    selectedLeveragesTemp,
    setSelectedLeveragesTemp,
    priceRangeTemp,
    tempselectedLocation,
    isResetClick,
    setIsResetClick,
    setTempSelectedLocation,
    setPriceRangeTemp,
    handleRemoveLeverage,
    handleRemoveLocationFilter,
    handleResetAllFilters,
  };
};

export default useFilters;
